var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buildPopup",on:{"click":_vm.showBuild}},[_c('div',{staticClass:"build"},[_c('div',{staticClass:"buildName"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }